import { useTranslation } from 'react-i18next';
import { type WhatsappLiveChatModuleSpecsFragment } from '../../../../../api/fragments/WhatsappLiveChatModuleSpecs';
import {
    CreateWhatsappLiveChatModuleDocument,
    type CreateWhatsappLiveChatModuleMutation,
    type CreateWhatsappLiveChatModuleMutationVariables,
} from '../../../../../api/mutations/createWhatsappLiveChatModule';
import { type WhatsappLiveChatModuleInput } from '../../../../../api/types';
import InputField from '../../../../../components/fields/InputField';
import validators from '../../../../../utilities/validators';
import WhatsappLiveChatModulePage, { type WhatsappLiveChatModulePageProps } from '../../WhatsappLiveChatModulePage';
import { type ModuleImplementation } from './types';

const implementation: ModuleImplementation<WhatsappLiveChatModuleSpecsFragment, WhatsappLiveChatModuleInput> = {
    PageComponent: ({ module }: WhatsappLiveChatModulePageProps) => <WhatsappLiveChatModulePage module={module} />,
    getTitle: t => t('moduleDetails:implementations.WhatsappLiveChatModule.className'),
    getValidator: () => validators.requiredNonEmptyString('displayName'),
    FormComponent: () => {
        const { t } = useTranslation(['moduleDetails']);

        return (
            <InputField
                {...t('moduleDetails:fields.displayName', { returnObjects: true })}
                name="displayName"
                required
            />
        );
    },
    create: async (apolloClient, companyId, values) =>
        apolloClient
            .mutate<CreateWhatsappLiveChatModuleMutation, CreateWhatsappLiveChatModuleMutationVariables>({
                mutation: CreateWhatsappLiveChatModuleDocument,
                variables: {
                    companyId,
                    settings: values,
                },
            })
            .then(({ data }) => data.module),
};

export default implementation;
